var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.$_can("carriers.movers.invite")
          ? _c(
              "div",
              { staticClass: "col-4 text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { to: "/movers/pending" }
                  },
                  [_vm._v("Check pending invitations")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        _vm.showInviteModal = true
                      }
                    }
                  },
                  [_vm._v("\n        INVITE MOVERS\n      ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$_can("carriers.movers.store")
          ? _c("div", { staticClass: "col-2 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      _vm.showCreateSidebar = !_vm.showCreateSidebar
                    }
                  }
                },
                [_vm._v("\n        ADD MOVER\n      ")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 filters-field" }, [
          _c("span", [_vm._v("Filters:")]),
          _vm._v(" "),
          _vm.filtersLoaded
            ? _c("span", [
                _vm.filters.carrier.length && _vm.carriers
                  ? _c(
                      "span",
                      _vm._l(_vm.filters.carrier, function(carrier) {
                        return _c(
                          "span",
                          {
                            key: carrier,
                            staticClass: "filter-item btn btn-filter"
                          },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("carrier", _vm.carriers)
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Carrier: " +
                                _vm._s(
                                  _vm.carriers.find(function(el) {
                                    return el.id === carrier
                                  }).name
                                )
                            )
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.status
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("status")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Status: " +
                          _vm._s(
                            _vm.moverStatuses.find(function(el) {
                              return el.id === _vm.filters.status
                            }).name
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.foreman !== ""
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("foreman")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Foreman: " +
                          _vm._s(_vm.filters.foreman === 1 ? "Yes" : "No")
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.ssn !== ""
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("ssn")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          SSN Verified: " +
                          _vm._s(_vm.filters.ssn === 1 ? "Yes" : "No")
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.inactive !== ""
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("inactive")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Show Inactive: " +
                          _vm._s(_vm.filters.inactive === 1 ? "Yes" : "No")
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary add-filters",
              on: {
                click: function($event) {
                  _vm.showFilters = true
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus filter-icon" })]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.movers
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _c("thead", { staticClass: "m-table__heading" }, [
                _c("tr", [
                  _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "users.first_name" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("users.first_name")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Name\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["users.first_name"]
                          ? "dsc"
                          : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "users.email" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("users.email")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Email\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["users.email"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Foreman")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.movers, function(mover) {
                    return _c(
                      "tr",
                      {
                        key: mover.id,
                        staticClass: "pointer",
                        on: {
                          mouseup: function($event) {
                            _vm.$_can("carriers.movers.show") &&
                              _vm.view($event, mover.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(mover.id))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", [_vm._v(_vm._s(mover.first_name))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(mover.last_name && mover.last_name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(mover.email))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.phoneMask.maskedPhone(mover.phone)))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(mover.foreman ? "Yes" : "No"))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(mover.status.name))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.movers.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "8" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carriers",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.moverStatuses,
                                          "input-id": "status-select",
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Foreman")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "foreman-select",
                                          placeholder: "Foreman"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.foreman,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "foreman",
                                              $$v
                                            )
                                          },
                                          expression: "filters.foreman"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("SSN")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "ssn-verified-select",
                                          placeholder: "SSN Verified"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.ssn,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "ssn", $$v)
                                          },
                                          expression: "filters.ssn"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Show inactive")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "inactive-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.inactive,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "inactive",
                                              $$v
                                            )
                                          },
                                          expression: "filters.inactive"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showInviteModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _vm.showInviteModalMode === "separate"
                ? [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            [
                              _c("h4", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "Invite movers to mod24 for your carrier"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Select Carrier")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.carriers,
                                      label: "name"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.clearError($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.dataToSend.carrier_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataToSend,
                                          "carrier_id",
                                          $$v
                                        )
                                      },
                                      expression: "dataToSend.carrier_id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("error-field", {
                                attrs: {
                                  errors: _vm.errors,
                                  field: "carrier_id"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c("h5", [_vm._v("Email addresses")]),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            attrs: { autocomplete: "off" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.sendInvitations($event)
                              }
                            }
                          },
                          _vm._l(_vm.dataToSend.emails, function(email, index) {
                            return _c(
                              "div",
                              { key: "em-" + index },
                              [
                                _c("div", { staticClass: "row mb-2" }, [
                                  _c("div", { staticClass: "col-11" }, [
                                    _c("div", { staticClass: "select-wrap" }, [
                                      _c("label", [_vm._v("Enter email")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.dataToSend.emails[index],
                                            expression:
                                              "dataToSend.emails[index]"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "email",
                                          autocomplete: "false",
                                          placeholder: "email@example.com"
                                        },
                                        domProps: {
                                          value: _vm.dataToSend.emails[index]
                                        },
                                        on: {
                                          keydown: function($event) {
                                            _vm.clearError($event)
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.dataToSend.emails,
                                              index,
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-1 pt-3" }, [
                                    index > 0 ||
                                    _vm.dataToSend.emails.length !== 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn btn-clear",
                                            on: {
                                              click: function($event) {
                                                _vm.removeField(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-remove"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: {
                                    errors: _vm.errors,
                                    field: "emails." + index
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "emails" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn add-button mr-2",
                            on: { click: _vm.addField }
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "fa fa-plus",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]),
                            _vm._v("Add one more")
                          ]
                        ),
                        _vm._v("\n        or\n        "),
                        _c(
                          "span",
                          {
                            staticClass: "btn add-button ml-2",
                            on: {
                              click: function($event) {
                                _vm.showInviteModalMode = "bulk"
                              }
                            }
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "fa fa-plus",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]),
                            _vm._v(" Add many at once")
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary ld-ext-right",
                              class: _vm.loadingButton ? "running" : "",
                              attrs: {
                                type: "button",
                                disabled: _vm.buttonDisabled
                              },
                              on: { click: _vm.sendInvitations }
                            },
                            [
                              _vm._v(
                                "\n              Send invitations\n              "
                              ),
                              _c("div", { staticClass: "ld ld-ball ld-flip" })
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showInviteModalMode === "bulk"
                ? [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            [
                              _c("h4", { staticClass: "mb-3" }, [
                                _vm._v(
                                  "Invite movers to mod24 for your carrier:"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Select Carrier")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.carriers,
                                      label: "name"
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.clearError($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.dataToSend.carrier_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataToSend,
                                          "carrier_id",
                                          $$v
                                        )
                                      },
                                      expression: "dataToSend.carrier_id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("error-field", {
                                attrs: {
                                  errors: _vm.errors,
                                  field: "carrier_id"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("h5", [_vm._v("Enter multiple email addresses")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "select-wrap select-wrap-textarea"
                              },
                              [
                                _c("label", [_vm._v("Enter email addresses")]),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.emailsBulk,
                                      expression: "emailsBulk"
                                    }
                                  ],
                                  staticClass:
                                    "form-control select-wrap-textarea",
                                  attrs: {
                                    cols: "30",
                                    rows: "10",
                                    placeholder: ""
                                  },
                                  domProps: { value: _vm.emailsBulk },
                                  on: {
                                    keydown: function($event) {
                                      _vm.clearError($event)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.emailsBulk = $event.target.value
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "emails" }
                            }),
                            _vm._v(
                              "\n            Please use commas to separate email addresses entered. You can always\n            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "btn add-button",
                                on: {
                                  click: function($event) {
                                    _vm.showInviteModalMode = "separate"
                                  }
                                }
                              },
                              [_vm._v("go back")]
                            ),
                            _vm._v(
                              " to adding single\n            addresses.\n          "
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary ld-ext-right",
                              class: _vm.loadingButton ? "running" : "",
                              attrs: {
                                type: "button",
                                disabled: _vm.buttonDisabled
                              },
                              on: { click: _vm.sendInvitations }
                            },
                            [
                              _vm._v(
                                "\n              Send invitations\n              "
                              ),
                              _c("div", { staticClass: "ld ld-ball ld-flip" })
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCreateSidebar = false
                  }
                }
              },
              [
                _c("movers-create", {
                  staticClass: "sidebar-right",
                  on: {
                    cancel: function($event) {
                      _vm.showCreateSidebar = false
                    },
                    update: _vm.updateAfterCreating
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 l-m-b-20" }, [
      _c("h1", [_vm._v("Movers")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b717d22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b717d22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/movers/Movers.vue
// module id = null
// module chunks = 